<template>
  <div class="page">
    <header-title
      title="Close all open work request"
      @onRefresh="find"
      has-refresh
    ></header-title>

    <div class="s-filter-box">
      <a-form layout="inline" :model="search">
        <a-form-item label="Job ID">
          <a-input
            v-model:value="jobId"
            placeholder="Please input job_id"
            @pressEnter="find"
            allowClear
          />
        </a-form-item>
        <a-form-item>
          <a-button @click="find">
            <template #icon><SearchOutlined /></template>
            Find
          </a-button>
        </a-form-item>
      </a-form>
    </div>

    <div class="page-body">
      <a-spin :spinning="loading">
        <ul class="list">
          <li class="item" v-for="(value, key) in regionObj" :key="key">
            {{ key }}:{{ value }}
          </li>
        </ul>
        <div class="f-footer">
          <a-button
            class="button button-positive"
            type="primary"
            v-if="Object.keys(regionObj).length"
            @click="closeAll"
          >
            Close All
          </a-button>
        </div>
      </a-spin>
    </div>
  </div>
</template>

<script setup>
  import HeaderTitle from '@/layout/header-title'

  import request from '@/utils/request'

  import { SearchOutlined } from '@ant-design/icons-vue'
  import { message } from 'ant-design-vue'
  import { ref } from 'vue'

  const loading = ref(false)

  const jobId = ref('')
  const regionObj = ref({})

  const find = async () => {
    loading.value = true
    try {
      const { body } = await request({
        url: '/api/workrequest/search',
        method: 'get',
        params: { jobId: jobId.value },
      })
      regionObj.value = body
      loading.value = false
    } catch (e) {
      loading.value = false
    }
  }
  const closeAll = () => {
    const hide = message.loading('Requesting……', 0)
    request({
      url: 'api/workrequest/CloseAllWorkRequest',
      method: 'get',
      params: {
        jobId: jobId.value,
      },
    })
      .then(() => {
        hide()
        message.success('Success', 3, () => {
          jobId.value = ''
        })
      })
      .finally(() => {
        hide()
      })
  }
</script>

<style lang="less" scoped>
  @import '~@/styles/variables.less';

  .page-body {
    height: calc(100vh - 132px);
    overflow: hidden;
  }
  .s-filter-box {
    padding: 10px;
    background: #f2f3f5;
    border-bottom: 1px solid #dbdcdc;
  }
  .list {
    padding: 30px;
    margin: 0;
    list-style: none;
    .item {
      border-bottom: 1px solid #ddd;
      padding: 10px 0;
    }
  }
  .f-footer {
    text-align: center;
    padding-top: 20px;
    .ant-btn {
      min-width: 200px;
    }
  }
</style>
